import toast from 'react-hot-toast';
import { getAdSkipsLeft } from '../global-state/usage-data';
import { getUser } from '../global-state/user';
import { whenVisible } from '../utils/helpers';
import debugLog from './debug';

const log = (...args: any[]) => {
  debugLog({ logName: 'ad-skip-gate', logColor: 'darkblue' }, ...args);
};

let hasRecentlyPlayedFailToSkipAdSound = false;
let cancelNoAdSkipsToast = () => {};

export function allowAdSkipOrPlayFailedToSkipAdSound(player: {
  playFailToSkipAdSound: () => void;
}) {
  const adSkipCreditsLeft = getAdSkipsLeft().total;
  if (adSkipCreditsLeft) {
    return true;
  }

  // If called repeatedly, don't spam user w/ sounds / notifications (can happen if audio is loading, etc)
  if (!hasRecentlyPlayedFailToSkipAdSound) {
    const isSignedIn = Boolean(getUser());
    log(
      'Not skipping ad b/c user is',
      isSignedIn ? 'out of ad-skips' : 'not signed in',
      adSkipCreditsLeft
    );
    player.playFailToSkipAdSound();
    hasRecentlyPlayedFailToSkipAdSound = true;
    setTimeout(() => {
      hasRecentlyPlayedFailToSkipAdSound = false;
    }, 5000);

    // Show toast to user once tab is visible again (only show one toast if multiple are queued)
    cancelNoAdSkipsToast();
    cancelNoAdSkipsToast = whenVisible(() => {
      // Make sure user is still out of ad-skips before showing toast
      const adSkipCreditsLeft = getAdSkipsLeft().total;
      if (adSkipCreditsLeft) return () => {};

      const isSignedIn = Boolean(getUser());
      return toast.error(
        isSignedIn ? 'No ad-skips left' : 'Please sign in to skip ads'
      );
    });
  }

  return false;
}
